<!--<div class="min-w-fit min-h-350 bg-{{theme}} p-25 rounded-xs gap-40 border border-dark/20 {{theme === 'primary-faded' ? 'bg-primary/5' : theme === 'red-faded' ? 'bg-red' : ''}} w-full" [ngClass]="{'faded-background': theme === 'red-faded'}">-->
<!--  <ng-content></ng-content>-->
<!--</div>-->

<div class="bg-white p-4 shadow rounded-lg lg:px-6 w-full {{ scrollable ? 'overflow-y-auto' : 'overflow-y-visible' }}" [ngClass]="{'border-2 border-dashed border-sky-500': isDashedBorder, 'full-height': useFullHeight, 'overflow-y-auto': scrollable}">
  <ng-content></ng-content>
</div>
